import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type { RootState } from '@/store';

import type {
  FetchSentencaArbitralInput,
  SentencaArbitralDados,
} from '../../types/sentencaArbitral.types';
import {
  sentencaArbitralService,
  SentencaNaoPublicadaError,
  SentencaSemPermissaoError,
} from './services';

// Rejeições com semântica própria: SEM_PERMISSAO vira o estado "sem permissão" e NAO_PUBLICADA
// vira o estado Bloqueado (sentenca nula, sem erro) — nunca documento em branco (rn1).
export const SENTENCA_SEM_PERMISSAO = 'SEM_PERMISSAO' as const;
export const SENTENCA_NAO_PUBLICADA = 'NAO_PUBLICADA' as const;

export const fetchSentencaArbitral = createAsyncThunk<
  SentencaArbitralDados,
  FetchSentencaArbitralInput,
  { rejectValue: string; state: RootState }
>('sentencaArbitral/fetch', async ({ origem, id }, { rejectWithValue }) => {
  try {
    return await sentencaArbitralService.getSentenca(origem, id);
  } catch (error) {
    if (error instanceof SentencaSemPermissaoError) return rejectWithValue(SENTENCA_SEM_PERMISSAO);
    if (error instanceof SentencaNaoPublicadaError) return rejectWithValue(SENTENCA_NAO_PUBLICADA);
    return rejectWithValue(getErrorMessage(error));
  }
});
